export enum EmployeeElementType {
  AL = 'AL',
  SICK = 'Sickness',
  CONTRACT = 'Contract',
  EXTRAS = 'Extras'
}
